import React from 'react';
import { Typography, Box, Paper } from '@mui/material';
import CountUp from 'react-countup';
import en_ja from '../../translations/en_ja';

const Cards = ({ title, value, icon, change, iconBgColor, prefix = "" }) => {

  // const isPositive = change && change.toString().startsWith('+');

  return (
    <Paper
      elevation={0}
      sx={{
        height: "100%",
        p: 3,
        borderRadius: "16px",
        border: "1px solid #e9ecef",
        backgroundColor: "white",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          boxShadow: "0 12px 32px rgba(0,0,0,0.12)",
          transform: "translateY(-4px)",
        },
      }}
    >
      {/* Text Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          height: "100%",
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",  
          }}
        >
          <Typography
            variant="body2"
            color="#6c757d"
            sx={{ fontSize: "14px", fontWeight: "500", mb: 1 }}
          >
            {title}
          </Typography>

          <Typography
            variant="h4"
            fontWeight="700"
            color="#1a1a1a"
            sx={{ fontSize: "28px", mb: 0.5 }}
          >
            <CountUp end={value || 0} duration={1} separator="," prefix={prefix} />
          </Typography>

          {change && (
            <Typography
              variant="body2"
              sx={{ fontSize: "12px", fontWeight: "600", color: "#28a745" }}
            >
              {change}% {en_ja["from last month"]}
            </Typography>
          )}

        </Box>

        {icon && (
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: "12px",
              background: iconBgColor || "#dc3545",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            {icon}
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default Cards;
